var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorld(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "world") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "world",
    fill: "#111111"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.53675,8.25 L5.262,8.25 C5.3265,6.20025 5.6565,4.33275 6.174,2.91 C6.30675,2.5455 6.4545,2.20125 6.61875,1.88625 C3.8715,2.805 1.833,5.271 1.53675,8.25 Z M9,0 C4.02975,0 0,4.02975 0,9 C0,13.97025 4.02975,18 9,18 C13.97025,18 18,13.97025 18,9 C18,4.02975 13.97025,0 9,0 Z M9,1.5 C8.88675,1.5 8.682,1.56075 8.40075,1.887 C8.1225,2.211 7.8375,2.724 7.58325,3.42225 C7.1355,4.65525 6.82725,6.342 6.76275,8.25 L11.23725,8.25 C11.17275,6.342 10.8645,4.65525 10.41675,3.42225 C10.1625,2.724 9.8775,2.211 9.59925,1.887 C9.318,1.56075 9.11325,1.5 9,1.5 Z M12.738,8.25 C12.67275,6.20025 12.3435,4.33275 11.826,2.91 C11.69325,2.5455 11.5455,2.20125 11.38125,1.88625 C14.1285,2.805 16.167,5.271 16.46325,8.25 L12.738,8.25 Z M11.23725,9.75 L6.76275,9.75 C6.82725,11.658 7.1355,13.34475 7.58325,14.57775 C7.8375,15.276 8.1225,15.789 8.40075,16.113 C8.682,16.43925 8.88675,16.5 9,16.5 C9.11325,16.5 9.318,16.43925 9.59925,16.113 C9.8775,15.789 10.1625,15.276 10.41675,14.57775 C10.8645,13.34475 11.17275,11.658 11.23725,9.75 Z M11.38125,16.11375 C11.5455,15.79875 11.69325,15.4545 11.826,15.09 C12.3435,13.66725 12.67275,11.79975 12.738,9.75 L16.46325,9.75 C16.167,12.729 14.1285,15.195 11.38125,16.11375 Z M6.61875,16.11375 C6.4545,15.79875 6.30675,15.4545 6.174,15.09 C5.6565,13.66725 5.3265,11.79975 5.262,9.75 L1.53675,9.75 C1.833,12.729 3.8715,15.195 6.61875,16.11375 L6.61875,16.11375 Z",
    id: "Fill-1152-Copy"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorld);
export default __webpack_public_path__ + "static/media/world.01794af2b66d435505c59de10675693a.svg";
export { ForwardRef as ReactComponent };